import { DaymapQuery as i } from "../../daymapQuery.js";
var t;
((n) => {
  class o extends i {
    constructor({ studentId: e, taskId: s, enabled: r = !0 }) {
      super(
        ["extensionRequest", s, e],
        { studentId: e, taskId: s },
        `/lms/api/assessment/extension/details?taskId=${s}&studentId=${e}`,
        null,
        { stale: 1e3 * 60, enabled: r }
        // 1 minute
      );
    }
  }
  n.GetExtensionRequest = o;
})(t || (t = {}));
export {
  t as extensionrequest
};
//# sourceMappingURL=index.js.map
